/**
 * Returns a link to Google Maps that will display a specified latitude and longitude.
 *
 * @param {Object} geo API geolocation object containing { latitude, longitude }.
 * @return A string link to Google maps displaying the coordinates
 */
export const googleMapsLink = ({ latitude, longitude }) => `https://maps.google.com/maps?q=${latitude},${longitude}`
